import * as Yup from 'yup';
import { phoneRegExp } from '../_constants';

export const USER_REGISTER_VALIDATIONS = {
  password: Yup.string()
    .required('Contaseña es requerido')
    .min(8, 'La longitud de la contraseña debe ser de al menos 8 caracteres'),
  passwordConfirm: Yup.string()
    .required('Confirmar contraseña es requerido')
    .oneOf([Yup.ref('password')], 'Las contraseñas deben coincidir'),
  firstName: Yup.string().required('Nombre es requerido'),
  app: Yup.string().required('Primer apellido es requerido'),
  apm: Yup.string().required('Segundo apellido'),
  email: Yup.string()
    .email('Ingresé un email valido')
    .required('Correo electrónico es requerido'),
  occupation: Yup.string().required('Profesion u Oficio es requerido'),
  rfc: Yup.string(),
  curp: Yup.string(),
  phone: Yup.string()
    .matches(phoneRegExp, 'Teléfono no valido')
    .required('Teléfono es requerido'),
  terms: Yup.boolean().oneOf(
    [true],
    'Por favor acepta los terminos y condiciones'
  ),
};

export const LOGIN_VALIDATIONS = {
  password: Yup.string()
    .required('Contaseña es requerido')
    .min(8, 'La longitud de la contraseña debe ser de al menos 8 caracteres'),
  email: Yup.string()
    .email('Ingresé un email valido')
    .required('Correo electrónico es requerido'),
};
